var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    ref: "editor",
    staticClass: "editor",
    attrs: { contenteditable: _vm.editable },
    domProps: { innerHTML: _vm._s(_vm.editorText) },
    on: {
      input: _vm.handleInput,
      focus: _vm.handleFocus,
      blur: _vm.handleBlur,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }